export const buildLineChartjsStackedOptionsProp = () => {
  return {
    plugins: {
      legend: {
        display: true,
        position: 'bottom'
      }
    },
    scales: {
      y: {
        max: 100,
        ticks: {
          callback: (value, _index, _ticks) => {
            return `${value}%`
          }
        }
      }
    }
  }
}
